import { render, staticRenderFns } from "./WorkflowSteps.vue?vue&type=template&id=d72e544e&scoped=true"
import script from "./WorkflowSteps.vue?vue&type=script&lang=js"
export * from "./WorkflowSteps.vue?vue&type=script&lang=js"
import style0 from "./WorkflowSteps.vue?vue&type=style&index=0&id=d72e544e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72e544e",
  null
  
)

export default component.exports